import { ReactNode, SyntheticEvent, useState } from 'react';
import { Box, Tab, Tabs as MuiTabs } from '@mui/material';

type TabsProps = {
  items: ReactNode[];
  getTabName: (index: number) => ReactNode;
  initialTab?: number;
};
export const Tabs = ({ items, getTabName, initialTab = 0 }: TabsProps) => {
  const [activeTab, setActiveTab] = useState(initialTab);

  const handleChange = (event: SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };
  return (
    <Box sx={{ border: 1, borderRadius: 1, borderColor: 'divider' }}>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
        }}
      >
        <MuiTabs
          value={activeTab}
          onChange={handleChange}
          aria-label="tabs"
          variant="fullWidth"
          // disable the tab indicator because it doesn't work well with wrapped container
          TabIndicatorProps={{ sx: { display: { xs: 'none', sm: 'block' } } }}
          sx={{
            '& .MuiTabs-flexContainer': {
              flexWrap: 'wrap',
            },
          }}
        >
          {items.map((_, index) => (
            <Tab id={`tab-${index}`} label={getTabName(index)} key={index} />
          ))}
        </MuiTabs>
      </Box>
      {items.map((item, index) => (
        <TabPanel value={activeTab} index={index} key={index}>
          {item}
        </TabPanel>
      ))}
    </Box>
  );
};

interface TabPanelProps {
  children?: ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`tabpanel-${index}`} aria-labelledby={`tab-${index}`} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}
